import errorResponseHandler from '@data/helpers/errorResponseHandler';
import authAxios from '@services/authAxios';

const fetchStores = async ({ queries }) => {
    try {
        const { data } = await authAxios({
            method: 'GET',
            url: `/api/v1/user/customer-dc?${queries}`,
        });

        return data?.data;
    } catch (error) {
        const errorMessage = errorResponseHandler(error);
        throw new Error(errorMessage);
    }
};

export default fetchStores;
